// Client configuration for the Novaeon *website backend* Firebase project
// (`novaeon-web`) — the one that hosts the contactForm Cloud Function. This is a
// SEPARATE project from VAE (`novaeon-vae`), so the site talks to two projects on
// one page; each is initialized as its own NAMED Firebase app (see client.ts).
//
// Every value here is PUBLIC (it ships in the browser bundle by design) — not a
// secret. The only real secret, the Gmail App Password, lives server-side in the
// function.
//
// Supply these via env vars at build time (.env / .env.local, or your host's env).
// Until they're present, the contact form falls back to a "email us directly"
// message instead of erroring — so the UI works before the backend is configured.

const env = process.env;

export const FIREBASE_CONFIG = {
  apiKey: env.REACT_APP_SITE_API_KEY ?? "",
  authDomain: env.REACT_APP_SITE_AUTH_DOMAIN ?? "",
  projectId: env.REACT_APP_SITE_PROJECT_ID ?? "",
  appId: env.REACT_APP_SITE_APP_ID ?? "",
};

export const RECAPTCHA_SITE_KEY = env.REACT_APP_SITE_RECAPTCHA_SITE_KEY ?? "";

// Region the function is deployed to (matches setGlobalOptions in the backend).
export const FUNCTIONS_REGION = "us-central1";

// The public inbox shown on the site + used as the "email us directly" fallback.
export const CONTACT_EMAIL = "hello@novaeon.io";

// The contact backend is "live" only when the essentials are configured.
export const CONTACT_CONFIGURED = Boolean(
  FIREBASE_CONFIG.projectId && FIREBASE_CONFIG.apiKey && FIREBASE_CONFIG.appId && RECAPTCHA_SITE_KEY,
);
